module.exports = __webpack_public_path__ + "static/media/mfALFA.5899fbc2.png";